export const REACT_INTL_DEFAULT_LOCALE = 'en-US';
